<template>
  <component v-bind:is="component" />
</template>

<script>
import { mapState } from 'vuex'

import CreditCard from './CreditCard'
import MercadoPago from './MercadoPago'

export default {
  name: 'InstantPaymentsIndex',
  components: {
    CreditCard,
    MercadoPago
  },
  computed: {
    ...mapState(['device']),
    component () {
      const type = this.handleTypePayment(this.device.payment.typePayment)
      if (type === 'MercadoPago') return MercadoPago
      return CreditCard
    }
  },
  methods: {
    handleTypePayment (type) {
      return type.split('_').map((el) => {
        return el.charAt(0).toUpperCase() + el.slice(1).toLowerCase()
      }).join('')
    }
  }
}
</script>
